import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=37aa6a0c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=37aa6a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa6a0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37aa6a0c')) {
      api.createRecord('37aa6a0c', component.options)
    } else {
      api.reload('37aa6a0c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=37aa6a0c&scoped=true&", function () {
      api.rerender('37aa6a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Gr4SuFErSqSY/JS/comp/DocBox.vue"
export default component.exports